import { css, styled } from '../../stitches.config';

export const panelCSS = css({
  backgroundColor: 'white',
  borderRadius: '$small',
  boxShadow: '$small',
});

export const Panel = styled('div', panelCSS);
